import { createFileRoute } from "@tanstack/react-router";
import { InboxPage } from "../../../features/inbox/components/inbox-page";
import { inboxSearchSchema } from "../../../features/inbox/search";
import { mergeSearch } from "../../../lib/search";

export const Route = createFileRoute("/w/$slug/inbox")({
  validateSearch: inboxSearchSchema,
  component: () => {
    const navigate = Route.useNavigate();
    return (
      <InboxPage
        view="inbox"
        search={Route.useSearch()}
        onSearch={(next) =>
          void navigate({ search: (previous) => mergeSearch<typeof previous>(previous, next) })
        }
      />
    );
  },
});
